import { useLocation } from 'react-router-dom';

const useQueryParam = (query) => {
  return new URLSearchParams(useLocation().search).get(query)
}

export default useQueryParam